export const initialState = {
  filterInfo: {
    isECommerceMessage: true,
    referenceIdList: [] as number[],
    ofsCenterMessageType: null as any,
    eCommerceMessageType: null as any,
    take: 10,
    skip: 0,
  },
};
